import {createMuiTheme} from '@material-ui/core';
import {InsightsThemeTokens} from './insightsTheme';

export function createInsightsPickersTheme(theme: InsightsThemeTokens) {
  return createMuiTheme({
    overrides: {
      MuiPopover: {
        paper: {
          backgroundColor: theme.cardBg,
          color: theme.text,
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          backgroundColor: theme.barBg,
          color: theme.text,
        },
        iconButton: {
          backgroundColor: theme.barBg,
          color: theme.disabledStateBlue,
        },
        dayLabel: {
          color: theme.altText,
        },
      },
      MuiPickersDay: {
        day: {
          color: theme.text,
        },
        daySelected: {
          backgroundColor: theme.activeStateBlue,
          color: theme.defaultNavy,
          '&:hover': {
            backgroundColor: theme.white,
          },
        },
        dayDisabled: {
          color: theme.navyGrey,
        },
        current: {
          color: theme.activeStateBlue,
        },
      },
    },
  });
}
